import { CHANNELS_TYPES } from '../enums/channels.enum';

export const CHANNELS: string[] = [
    CHANNELS_TYPES.ZOOM,
    CHANNELS_TYPES.YOUTUBE,
    CHANNELS_TYPES.UTPL_EVENTS,
    CHANNELS_TYPES.FACEBOOK,
];
